import { FulfillmentIcon } from 'icons';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumFulfillmentSettingRoutes } from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';

const fulfillmentSection: SettingsSidebarMenuItem = {
  icon: <FulfillmentIcon width={24} height={24} />,
  data: [
    {
      value: `/${EnumDeskRoutes.settings}/${EnumFulfillmentSettingRoutes.pickingAndPacking}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="general.picking-and-packing" />
        </div>
      ),
    },
  ],
  translationKey: 'dashboard.fulfillment',
};

export { fulfillmentSection };
